import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VInput } from 'vuetify/lib/components/VInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "text--black subtitle-1" }, [
        _vm._v(_vm._s(_vm.$t("descripcion.use_case_report"))),
      ]),
      _c(
        VTabs,
        {
          attrs: { "center-active": "", "fixed-tabs": "" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(VTab, [_vm._v(_vm._s(_vm.$t("titles.description")))]),
          _c(VTab, [_vm._v(_vm._s(_vm.$t("titles.attributes")))]),
          _vm.useCaseApproved
            ? _c(VTab, [
                _vm._v(
                  "SANDBOX" +
                    _vm._s(
                      _vm.useCase.source == "ATHENA" ? "(AWS)" : "(BigQuery)"
                    )
                ),
              ])
            : _vm._e(),
          _vm.useCaseApproved && _vm.isIbkDomain()
            ? _c(VTab, [
                _vm._v(
                  "SANBOX(" +
                    _vm._s(_vm.translate("tabs.sandbox_internal")) +
                    ")"
                ),
              ])
            : _vm._e(),
          _c(VTab, [_vm._v(_vm._s(_vm.$t("titles.logs")))]),
          _vm.item.company_code === "000"
            ? _c(VTab, [_vm._v(_vm._s(_vm.$t("titles.aws_exports")))])
            : _vm._e(),
          _vm.useCase.source === "ATHENA" && _vm.useCase.company_code === "000"
            ? _c(VTab, [_vm._v(_vm._s(_vm.$t("titles.base_exports")))])
            : _vm._e(),
        ],
        1
      ),
      _c(
        VTabsItems,
        {
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(
            VTabItem,
            [
              _c(
                VContainer,
                { attrs: { fluid: "" } },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("form_attrs_use_case.organization")
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9", lg: "4" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              filled: "",
                              readonly: "",
                              "hide-details": "auto",
                              dense: "",
                            },
                            model: {
                              value: _vm.useCase.organization,
                              callback: function ($$v) {
                                _vm.$set(_vm.useCase, "organization", $$v)
                              },
                              expression: "useCase.organization",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("form_attrs_use_case.use_case"))
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9", lg: "4" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              filled: "",
                              readonly: "",
                              "hide-details": "auto",
                              dense: "",
                            },
                            model: {
                              value: _vm.useCase.business_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.useCase, "business_name", $$v)
                              },
                              expression: "useCase.business_name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { staticClass: "mt-2", attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("form_attrs_use_case.users"))
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(
                            VChipGroup,
                            _vm._l(_vm.users, function (user) {
                              return _c(
                                VChip,
                                { key: user, staticClass: "mr-1" },
                                [
                                  _vm._v(
                                    _vm._s(user) +
                                      " " +
                                      _vm._s(
                                        _vm.isUserOwner(user)
                                          ? "(" +
                                              _vm.translate("frases.owner") +
                                              ")"
                                          : ""
                                      )
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { staticClass: "mt-2", attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "form_attrs_use_case.attributes_selected_number"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9", lg: "4" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              filled: "",
                              readonly: "",
                              "hide-details": "auto",
                              dense: "",
                            },
                            model: {
                              value: _vm.useCase.attribute_count,
                              callback: function ($$v) {
                                _vm.$set(_vm.useCase, "attribute_count", $$v)
                              },
                              expression: "useCase.attribute_count",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("form_attrs_use_case.expiration_date")
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9", lg: "4" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              filled: "",
                              readonly: "",
                              "hide-details": "auto",
                              dense: "",
                              "append-icon": "mdi-calendar",
                              value: "01-12-20222",
                            },
                            model: {
                              value: _vm.expirationDate,
                              callback: function ($$v) {
                                _vm.expirationDate = $$v
                              },
                              expression: "expirationDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { staticClass: "mt-2", attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("form_attrs_use_case.technical_name")
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9", lg: "4" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              filled: "",
                              readonly: "",
                              "hide-details": "auto",
                              dense: "",
                            },
                            model: {
                              value: _vm.useCase.technical_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.useCase, "technical_name", $$v)
                              },
                              expression: "useCase.technical_name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.businessAreas.length > 0
                        ? [
                            _c(
                              VCol,
                              { attrs: { cols: "3", lg: "2" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "form_attrs_use_case.business_area"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "9", lg: "4" } },
                              [
                                _c(VTextField, {
                                  attrs: {
                                    filled: "",
                                    readonly: "",
                                    "hide-details": "auto",
                                    dense: "",
                                    value: _vm.getBusinessArea
                                      ? _vm.getBusinessArea.name
                                      : "",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c(
                    VRow,
                    { staticClass: "mt-2", attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("form_attrs_use_case.detail"))
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VTextarea, {
                            attrs: {
                              filled: "",
                              readonly: "",
                              "hide-details": "auto",
                              dense: "",
                              rows: "2",
                            },
                            model: {
                              value: _vm.useCase.description_business,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.useCase,
                                  "description_business",
                                  $$v
                                )
                              },
                              expression: "useCase.description_business",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VTabItem,
            [
              _c(VTextField, {
                staticClass: "mx-1 hidden-xs-only mt-2",
                attrs: {
                  "prepend-inner-icon": "icon-search",
                  "hide-details": "",
                  filled: "",
                  rounded: "",
                  dense: "",
                  type: "search",
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
              _c(VDataTable, {
                staticClass: "text-center table-inca",
                attrs: {
                  responsive: "",
                  dense: "",
                  items: _vm.useCase.attributes,
                  headers: _vm.headersAttributesTab,
                  search: _vm.search,
                  "hide-default-footer": "",
                  "items-per-page": _vm.pagination.attributes.limit,
                  page: _vm.pagination.attributes.current,
                },
                on: {
                  pagination: function ($event) {
                    _vm.pagination.attributes.total = $event.itemsLength
                  },
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.attributes,
                      "current",
                      $event
                    )
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.attribute_source_id",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "span",
                                        _vm._g(
                                          _vm._b({}, "span", attrs, false),
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getAttributeSource(
                                                item.attribute_source_id
                                              ).name
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.getAttributeSource(
                                    item.attribute_source_id
                                  ).description
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("pagination-vue", {
                attrs: { pagination: _vm.pagination.attributes },
              }),
            ],
            1
          ),
          _vm.useCaseApproved
            ? _c(
                VTabItem,
                [
                  _c("sandbox-views-tab-component", {
                    attrs: { item: _vm.getUseCaseAndViews() },
                    on: { update: _vm.refreshSandboxTab },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.useCaseApproved && _vm.isIbkDomain()
            ? _c(
                VTabItem,
                [
                  _c("sandbox-views-tab-component", {
                    attrs: {
                      item: _vm.getUseCaseAndViews(_vm.TYPE_VIEWS.INTERNAL),
                    },
                    on: { update: _vm.refreshSandboxTab },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            VTabItem,
            [
              _c(VDataTable, {
                staticClass: "text-center table-inca",
                attrs: {
                  responsive: "",
                  dense: "",
                  items: _vm.useCaseLogs,
                  headers: _vm.headersLogsTab,
                  search: _vm.search,
                  "hide-default-footer": "",
                  "items-per-page": _vm.pagination.logs.limit,
                  page: _vm.pagination.logs.current,
                },
                on: {
                  pagination: function ($event) {
                    _vm.pagination.logs.total = $event.itemsLength
                  },
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination.logs, "current", $event)
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.status_logtype_id",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.getLogType(item.status_logtype_id))
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "item.creation_date",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(
                          VInput,
                          { attrs: { "prepend-icon": "mdi-calendar" } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getDateAndHours(item.creation_date).date
                              )
                            ),
                          ]
                        ),
                        _c(
                          VInput,
                          { attrs: { "prepend-icon": "mdi-clock-outline" } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getDateAndHours(item.creation_date).hour
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("pagination-vue", {
                attrs: { pagination: _vm.pagination.logs },
              }),
            ],
            1
          ),
          _vm.item.company_code === "000"
            ? _c(
                VTabItem,
                [
                  _c("log-aws-export-component", {
                    attrs: {
                      "log-items": _vm.logItems,
                      "log-headers": _vm.log_headers,
                      "get-date-and-hours": _vm.getDateAndHours,
                      "get-use-case-status": _vm.getUseCaseStatus,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.useCase.source === "ATHENA" && _vm.useCase.company_code === "000"
            ? _c(
                VTabItem,
                [
                  _c("export-base-tab-component", {
                    attrs: {
                      "base-items": _vm.baseExportItems,
                      "base-headers": _vm.base_export_headers,
                      "get-date-and-hours": _vm.getDateAndHours,
                      "get-use-case-status": _vm.getUseCaseStatus,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }